import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from '../../../services/user.service';
import { NgxPopupService } from '../../shared/ngx-popups/ngx-popups/services/ngx-popup.service';
import { ContactSupportComponent } from '../../shared/popups/contact-support/contact-support.component';
import { AutoUnsubscribe } from '../../../decorators/auto-unsubscribe';
import { BUILD_INFO } from '@utils/build-info';
import { NgxPopupComponent } from '../../shared/ngx-popups/ngx-popups/ngx-popups';
import { RestComponent } from '../../developer/command/rest/rest.component';
import { CacheComponent } from '../../developer/command/cache/cache.component';
import { SharedDataService } from '@services/shared-data.service';
import { AuthenticationService } from '@services/authentication.service';
import { Company } from '../../../models/company';
import { UserGuideService } from '@services/user-guide.service';
import {PLATFORM_PERMISSIONS} from "@utils/constants";
import {BankSettingsService} from "@services/bank-settings.service";
import { BackendVersionService } from '@services/backend-version.service';
import {
  ContactSupportEmailModalComponent
} from "@components/shared/popups/contact-support-email-modal/contact-support-email-modal.component";
import {LaunchDarklyService} from "@services/launchdarkly.service";

function formatFrontendVersion(): string {
  return BUILD_INFO.gitTag || BUILD_INFO.gitBranch || 'unknown';
}

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
@AutoUnsubscribe('_subsArr$')
export class HeaderComponent implements OnInit {
  subsArr$: Subscription[] = [];
  showSalesforceConnect = false;
  showManualReview = true;
  display: boolean;
  frontendVersion: string = formatFrontendVersion();
  backendVersion: string = 'unknown';
  company: Company;
  title: String;
  bankId: String = null;
  numDocuments = 0;
  userHasMultipleTenants: boolean;
  _subsArr$: Subscription[] = [];
  showDocumentStatusButton: boolean;
  showUploadStatusPopover = false;
  contactSupportEmail: string;
  customerSupportUrl: string;
  showStorylaneTrainingButton: boolean = false;
  showNumeratedSalesforceHelpLinks: boolean = false;

  constructor(
    public userService: UserService,
    public sanitizer: DomSanitizer, // Don't remove need in template
    private popupService: NgxPopupService,
    public _sharedDataService: SharedDataService,
    private _router: Router,
    public authenticationService: AuthenticationService,
    public userGuideService: UserGuideService,
    public _bankSettingsService: BankSettingsService,
    public launchDarklyService: LaunchDarklyService,
    private backendVersionService: BackendVersionService,
  ) { }

  ngOnInit() {
    this.getFeatureFlags();
    this.showDocumentStatusButton = this.userService.user.hasUserPermission(PLATFORM_PERMISSIONS.VIEW_DOCUMENT_STATUS_TRACKER)
    this._subsArr$.push(
      this._sharedDataService.company$.subscribe(company => {
        this.company = company;
      })
    );

    this._subsArr$.push(
      this._sharedDataService.pageHeaderTitle$.subscribe(title => {
        this.title = title;
      })
    );

    this._subsArr$.push(
      this._sharedDataService.numParsingTrackerDocuments$.subscribe(numDocuments => {
        this.numDocuments = numDocuments;
      })
    );

    this._subsArr$.push(this._bankSettingsService.getPortalSettings().subscribe((data) => {
      this.contactSupportEmail = data['_portalSettings']['contactSupportEmail'];
      this.customerSupportUrl = data['_portalSettings']['customerSupportUrl'];
    }));

    this.userHasMultipleTenants = this.userService.hasMultipleTenants();

    if (this.userHasMultipleTenants) {
      this.bankId = this.userService.user.bank_id;
      this._subsArr$.push(
        this.backendVersionService.getVersion().subscribe((version) => {
          this.backendVersion = version;
        })
      );
    }
  }

  user_name() {
    if (this.userService.user) {
      return this.userService.user.name;
    }
    return '';
  }

  /**
   * helper to open support window
   */
  openSupportWindow() {
    this.popupService.open({
      componentType: ContactSupportComponent,
      cssClass: 'modal-support'
    });
  }

  shouldDisplayManualReview(): boolean {
    return this.userService.isManualReviewer();
  }

  shouldDisplaySpreading(): boolean {
    return this.userService.isSpreader();
  }

  restCommander() {
    this.popupService.open({
      componentType: RestComponent,
      cssClass: 'modal-rest-commander',
    }).then((popup: NgxPopupComponent) => {
      popup.addEventListener('close', (data: CustomEvent) => {
      }, {once: true});
    });
  }

  cacheCommander() {
    this.popupService.open({
      componentType: CacheComponent,
      cssClass: 'modal-cache-commander',
    }).then((popup: NgxPopupComponent) => {
      popup.addEventListener('close', (data: CustomEvent) => {
      }, {once: true});
    });
  }

  switchTenant() {
    this._router.navigate(['/switch-tenant'])
  }

  openContactSupportEmailModal() {
    if (this.customerSupportUrl) {
        window.open(this.customerSupportUrl, '_blank');
        return;
    }
    this.popupService.open({
      componentType: ContactSupportEmailModalComponent,
      cssClass: 'contact-support-modal',
      inputs: {
        supportEmail: this.contactSupportEmail,
      },
    })
  }

  getFeatureFlags() {
    this.showStorylaneTrainingButton = this.launchDarklyService.flags['storylane-training-button'];
    this.subsArr$.push(this.launchDarklyService.flagChange.subscribe((flags) => {
      this.showStorylaneTrainingButton = flags['storylane-training-button'];
    }));

    this.showNumeratedSalesforceHelpLinks = this.launchDarklyService.flags['numerated-salesforce-help-links'];
    this.subsArr$.push(this.launchDarklyService.flagChange.subscribe((flags) => {
      this.showNumeratedSalesforceHelpLinks = flags['numerated-salesforce-help-links'];
    }));
  }
}
